import React from "react";

// 회비 가입 상태 뱃지: S 대기 / C 승인 / D 거절
export const feeStatusBadge = (status) => {
  if (status === "S")
    return <span className="label label-warning">대기</span>;
  if (status === "C")
    return <span className="label label-success">승인</span>;
  if (status === "D")
    return <span className="label label-danger">거절</span>;
  return <span className="label label-default">-</span>;
};
